export enum UI_THEMES {
  LIGHT = "light",
  DARK = "dark",
}
